import { Toaster as Sonner, toast } from "sonner"

/**
 * Custom Toaster for THE ONESCENT DIAL
 * Styled to match the brass/cosmic aesthetic
 */
const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#0B0F19] group-[.toaster]:text-[#E6C288] group-[.toaster]:border group-[.toaster]:border-[#C5A059]/50 group-[.toaster]:shadow-lg group-[.toaster]:shadow-[#C5A059]/10",
          description: "group-[.toast]:text-[#94A3B8]",
          actionButton:
            "group-[.toast]:bg-[#C5A059] group-[.toast]:text-[#050814] group-[.toast]:font-bold",
          cancelButton:
            "group-[.toast]:bg-[#1a1f2e] group-[.toast]:text-[#94A3B8] group-[.toast]:border group-[.toast]:border-[#C5A059]/30",
          success: "group-[.toaster]:border-[#7ED321]/50 group-[.toaster]:text-[#7ED321]",
          error: "group-[.toaster]:border-[#FF6B6B]/50 group-[.toaster]:text-[#FF6B6B]",
          warning: "group-[.toaster]:border-[#F5A623]/50 group-[.toaster]:text-[#F5A623]",
          info: "group-[.toaster]:border-[#9370DB]/50 group-[.toaster]:text-[#DDA0DD]",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
